import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { compoundManagementSlice, getVehicleInventoryBulkSelection } from '../../../reducers/compoundManagementSlice';
import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import { useGetInventoryVehicleIdsMutation } from '../../../api/compoundManagementApi';
import { FIXED_CACHE_KEY } from './VehicleInventoryBulkSelectionDropdown';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

export const CONTENT_LOADER_TEST_ID = 'inventory-selection-cell-loader';

type SelectionCellProps = {
    vehicleId: string;
};

export const InventorySelectionCell = ({ vehicleId }: SelectionCellProps) => {
    const isSelected = useAppSelector((state) => getVehicleInventoryBulkSelection(state).includes(vehicleId));
    const dispatch = useAppDispatch();
    const [, { isLoading }] = useGetInventoryVehicleIdsMutation({ fixedCacheKey: FIXED_CACHE_KEY });

    const onSelect = () => {
        if (isSelected) {
            dispatch(compoundManagementSlice.actions.removeFromInventoryBulkSelection([vehicleId]));
        } else {
            dispatch(compoundManagementSlice.actions.addToInventoryBulkSelection([vehicleId]));
        }
    };

    const ariaLabel = isSelected ? 'Remove vehicle from selection' : 'Add vehicle to selection';

    return (
        <td className="table-checkbox">
            {isLoading ? (
                <ContentLoader data-testid={CONTENT_LOADER_TEST_ID} />
            ) : (
                <Checkbox onChange={onSelect} checked={isSelected} aria-label={ariaLabel} />
            )}
        </td>
    );
};
